import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";


@Component({ name: "BannerMarketing"})
export default class BannerMarketing extends Vue{

    @Prop() readonly marketingBanner:any;
    @Prop() readonly isHome:boolean;
}